// import helpers
import { getFileExtension } from '@/helpers/utils/checkFileUrlType/getFileExtension'

/**
 * Check if a file URL is an image
 * Supported: jpg, jpeg, png, gif, webp, bmp, svg
 * @param fileUrl - The URL of the file
 * @returns boolean
 */
export const isImageFile = (fileUrl: string | null | undefined): boolean => {
  const extension = getFileExtension(fileUrl)

  return (
    extension === 'jpg' ||
    extension === 'jpeg' ||
    extension === 'png' ||
    extension === 'gif' ||
    extension === 'webp' ||
    extension === 'bmp' ||
    extension === 'svg'
  )
}
